import DataTable, {Order} from "datatables.net-bs5";
import {AjaxData} from "datatables.net";
import {get, notifier, number_format, on, on_keyup} from "../util";

declare const eo_version : string;

interface ItemsAjaxData extends AjaxData {
    type : string
}

export default class {
    static init = () => {
        items();
        sets();
        compare();
    }
}

function items() {
    let table = document.querySelector('.datatable[data-table="eo_items"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="eo_items"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100,500,1000,2000],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getItems',
            data: function (data: ItemsAjaxData, settings) {
                let type = document.querySelector('.js-eo-filter-type') as HTMLSelectElement;
                data.type = type.value;
                let search = settings.oPreviousSearch.search;
                let gold = document.querySelector('.js-total-eons') as HTMLElement;
                if(gold) {
                    get('?do=getTotalEons', {search: search}, (data: any) => {
                        if(data) {
                            gold.innerText = number_format(data,0);
                        }
                    });
                }
                return data;
            }
        },
        columns: [
            { data: 'id', className: "align-middle", width: "25px" },
            { data: null, className: "align-middle", width: "250px", render: function(data) {
                    return `<img src="/assets/eo/${eo_version}/items/${data.id}.png" class="eo-item-image-small" /> <a href="/eo/items/${data.id}">${data.name}</a>`;
                }},
            { data: null, className: "align-middle td-editable", render: function(data : any) {
                    return `<span class="js-trade-view" data-id="${data.id}" data-min="${data.trade_min}" data-max="${data.trade_max}">${data.trade}</span>`;
                } },
            { data: null, className: "align-middle td-editable", width: "110px", render: function(data : any) {
                    return `<span class="js-buy-view" data-id="${data.id}">${data.buy}</span>`;
                } },
            { data: 'value', className: "align-middle", width: "110px" },
            { data: null, className: "align-middle td-editable", width: "110px", render: function(data : any) {
                    return `<span class="js-witch-view" data-id="${data.id}">${data.value_witch}</span>`;
                } },
            { data: 'crafting', className: "align-middle", width: "160px" },
            { data: null, className: "align-middle td-editable", width: "110px", render: function(data : any) {
                    return `<span class="js-eo-amount-view" data-id="${data.id}">${data.amount}</span>`;
                } },
            { data: null, className: "align-middle", width: "110px", render: (data) => data.total === null ? '-' : number_format(data.total,0) },
        ],
        order: [[0,"asc"]] as Order[]
    });

    on('click','.js-witch-view',(target : HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let amount = target.innerText ?? "0";

        let input = document.createElement('input');
        input.type = 'number';
        input.step = '1';
        input.value = amount;
        input.classList.add('form-control', 'form-control-sm', 'js-witch-edit');
        input.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        td.innerHTML = '';
        td.appendChild(input);

        input.focus();
    },true);

    on('click','.js-buy-view',(target : HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let amount = target.innerText ?? "0";

        let input = document.createElement('input');
        input.type = 'number';
        input.step = '1';
        input.value = amount;
        input.classList.add('form-control', 'form-control-sm', 'js-buy-edit');
        input.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        td.innerHTML = '';
        td.appendChild(input);

        input.focus();
    },true)

    on('click','.js-eo-amount-view',(target : HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let amount = target.innerText ?? "0";

        let input = document.createElement('input');
        input.type = 'number';
        input.step = '1';
        input.value = amount;
        input.classList.add('form-control', 'form-control-sm', 'js-eo-amount-edit');
        input.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        td.innerHTML = '';
        td.appendChild(input);

        input.focus();
    },true);

    on('click','.js-trade-view',(target : HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let min = target.getAttribute('data-min') ?? "0";
        let max = target.getAttribute('data-max') ?? "0";

        let input_min = document.createElement('input');
        input_min.type = 'number';
        input_min.step = '1';
        input_min.value = min;
        input_min.classList.add('form-control', 'form-control-sm', 'js-trade-min-edit');
        input_min.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        let input_max = document.createElement('input');
        input_max.type = 'number';
        input_max.step = '1';
        input_max.value = max;
        input_max.classList.add('form-control', 'form-control-sm', 'js-trade-max-edit');
        input_max.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        let separator = document.createElement('span');
        separator.innerText = '-';
        separator.classList.add('input-group-text');

        let group = document.createElement('div');
        group.classList.add('input-group','w-100');
        group.appendChild(input_min);
        group.appendChild(separator);
        group.appendChild(input_max);

        td.innerHTML = '';
        td.appendChild(group);

        input_min.focus();
    },true);

    on('focusout','.js-witch-edit',(target : HTMLInputElement) => update_witch_from_table(target),true);
    on_keyup(13,'.js-witch-edit',(target : HTMLInputElement) => update_witch_from_table(target));

    on('focusout','.js-buy-edit',(target : HTMLInputElement) => update_buy_from_table(target),true);
    on_keyup(13,'.js-buy-edit',(target : HTMLInputElement) => update_buy_from_table(target));

    on('focusout','.js-eo-amount-edit',(target : HTMLInputElement) => update_amount_from_table(target),true);
    on_keyup(13,'.js-eo-amount-edit',(target : HTMLInputElement) => update_amount_from_table(target));

    on('focusout','.js-trade-min-edit',(target : HTMLInputElement) => update_sell_from_table(target),true);
    on_keyup(13,'.js-trade-min-edit',(target : HTMLInputElement) => update_sell_from_table(target));
    on('focusout','.js-trade-max-edit',(target : HTMLInputElement) => update_sell_from_table(target),true);
    on_keyup(13,'.js-trade-max-edit',(target : HTMLInputElement) => update_sell_from_table(target));

    function update_witch_from_table(input: HTMLInputElement) {
        let id = parseInt(input.getAttribute('data-id') ?? "0");
        let value = parseInt(input.value);
        get('?do=updateWitchValue', {item_id: id, value: value},(data : any) => {
            if(data.status == 1) {
                notifier.success("Witch value has been updated.");
            } else {
                notifier.alert(data.message);
            }
            datatable.ajax.reload(() => {},false);
        });
    }

    function update_amount_from_table(input: HTMLInputElement) {
        let id = parseInt(input.getAttribute('data-id') ?? "0");
        let value = parseInt(input.value);
        get('?do=updateAmount', {
            item_id: id,
            value: isNaN(value) ? 0 : value
        },(data : any) => {
            if(data.status == 1) {
                notifier.success("Amount has been updated.");
            } else {
                notifier.alert(data.message);
            }
            datatable.ajax.reload(() => {},false);
        });
    }

    function update_buy_from_table(input: HTMLInputElement) {
        let id = parseInt(input.getAttribute('data-id') ?? "0");
        let value = parseInt(input.value);
        get('?do=updateBuy', {item_id: id, value: value},(data : any) => {
            if(data.status == 1) {
                notifier.success("Buy price has been updated.");
            } else {
                notifier.alert(data.message);
            }
            datatable.ajax.reload(() => {},false);
        });
    }

    function update_sell_from_table(input: HTMLInputElement) {
        setTimeout(() => {
            if(document.activeElement !== input && (document.activeElement?.classList.contains('js-trade-min-edit') || document.activeElement?.classList.contains('js-trade-max-edit'))) {
                return;
            }
            let id = parseInt(input.getAttribute('data-id') ?? "0");
            let td = (input?.parentElement as HTMLElement);
            let min = parseInt((td.querySelector('.js-trade-min-edit') as HTMLInputElement).value);
            let max = parseInt((td.querySelector('.js-trade-max-edit') as HTMLInputElement).value);
            min = isNaN(min) ? 0 : min;
            max = isNaN(max) ? 0 : max;
            get('?do=updateSell', {item_id: id, min: min, max: max},(data : any) => {
                if(data.status == 1) {
                    notifier.success("Sell price has been updated.");
                } else {
                    notifier.alert(data.message);
                }
                datatable.ajax.reload(() => {},false);
            });
        }, 5);
    }

    on('change', '.js-eo-filter-type', (target: HTMLInputElement) => {
        datatable.ajax.reload(() => {},false);
    });
}

function sets() {
    let table = document.querySelector('.datatable[data-table="eo_sets"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="eo_sets"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getSets',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: null, className: "align-middle", render: function(data) {
                    let html = '';
                    data.items.forEach((item_id : any) => {
                        html += `<a href="/eo/items/${item_id}"><img src="/assets/eo/${eo_version}/items/${item_id}.png" class="eo-item-image-small" /></a>`;
                    });
                    html += ` ${data.name}`;
                    return html;
                }},
            { data: null, className: "align-middle td-editable", render: function(data : any) {
                    return `<span class="js-trade-view" data-id="${data.id}" data-min="${data.trade_min}" data-max="${data.trade_max}">${data.trade}</span>`;
                } },
            { data: 'craft', className: "align-middle" },
        ],
        order: [[0,"asc"]] as Order[]
    });

    on('click','.js-trade-view',(target : HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let min = target.getAttribute('data-min') ?? "0";
        let max = target.getAttribute('data-max') ?? "0";

        let input_min = document.createElement('input');
        input_min.type = 'number';
        input_min.step = '1';
        input_min.value = min;
        input_min.classList.add('form-control', 'form-control-sm', 'js-trade-min-edit');
        input_min.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        let input_max = document.createElement('input');
        input_max.type = 'number';
        input_max.step = '1';
        input_max.value = max;
        input_max.classList.add('form-control', 'form-control-sm', 'js-trade-max-edit');
        input_max.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        let separator = document.createElement('span');
        separator.innerText = '-';
        separator.classList.add('input-group-text');

        let group = document.createElement('div');
        group.classList.add('input-group','w-100');
        group.appendChild(input_min);
        group.appendChild(separator);
        group.appendChild(input_max);

        td.innerHTML = '';
        td.appendChild(group);

        input_min.focus();
    },true);

    on('focusout','.js-trade-min-edit',(target : HTMLInputElement) => update_trade_from_table(target),true);
    on_keyup(13,'.js-trade-min-edit',(target : HTMLInputElement) => update_trade_from_table(target));
    on('focusout','.js-trade-max-edit',(target : HTMLInputElement) => update_trade_from_table(target),true);
    on_keyup(13,'.js-trade-max-edit',(target : HTMLInputElement) => update_trade_from_table(target));

    function update_trade_from_table(input: HTMLInputElement) {
        setTimeout(() => {
            if(document.activeElement !== input && (document.activeElement?.classList.contains('js-trade-min-edit') || document.activeElement?.classList.contains('js-trade-max-edit'))) {
                return;
            }
            let id = parseInt(input.getAttribute('data-id') ?? "0");
            let td = (input?.parentElement as HTMLElement);
            let min = parseInt((td.querySelector('.js-trade-min-edit') as HTMLInputElement).value);
            let max = parseInt((td.querySelector('.js-trade-max-edit') as HTMLInputElement).value);
            min = isNaN(min) ? 0 : min;
            max = isNaN(max) ? 0 : max;
            get('?do=updateSetTrade', {item_id: id, min: min, max: max},(data : any) => {
                if(data.status == 1) {
                    notifier.success("Trade price has been updated.");
                } else {
                    notifier.alert(data.message);
                }
                datatable.ajax.reload(() => {},false);
            });
        }, 5);
    }
}

function compare() {
    let compare1 = document.querySelector('.js-eo-compare-1') as HTMLSelectElement;
    let compare2 = document.querySelector('.js-eo-compare-2') as HTMLSelectElement;
    if(!compare1) {
        return;
    }

    compare1.addEventListener('change', compare_change);
    compare2.addEventListener('change', compare_change);

    function compare_change() {
        let id1 = compare1.value;
        let id2 = compare2.value;
        window.location.href = '/eo/compare/' + id1 + '/' + id2;
    }

    document.querySelectorAll('.btn-eo-compare-original').forEach((btn) => {
        btn.addEventListener('click', function() {
            btn.classList.remove('btn-outline-secondary');
            btn.classList.add('btn-secondary');
            document.querySelectorAll('.btn-eo-compare-calculated').forEach((el) => {
                el.classList.remove('btn-secondary');
                el.classList.add('btn-outline-secondary');
            });
            document.querySelectorAll('.table-eo-compare-calculated').forEach((el) => {
                el.classList.add('d-none');
            });
            document.querySelectorAll('.table-eo-compare').forEach((el) => {
                el.classList.remove('d-none');
            });
        });
    });

    document.querySelectorAll('.btn-eo-compare-calculated').forEach((btn) => {
        btn.addEventListener('click', function() {
            btn.classList.remove('btn-outline-secondary');
            btn.classList.add('btn-secondary');
            document.querySelectorAll('.btn-eo-compare-original').forEach((el) => {
                el.classList.remove('btn-secondary');
                el.classList.add('btn-outline-secondary');
            });
            document.querySelectorAll('.table-eo-compare').forEach((el) => {
                el.classList.add('d-none');
            });
            document.querySelectorAll('.table-eo-compare-calculated').forEach((el) => {
                el.classList.remove('d-none');
            });
        });
    });
}
